<div class="full-grow-no-shrink-no-basis">
  <div class="orbitax-services-content simple-scroll full-grow-no-shrink-no-basis">
    <dl>
      <dt>Board</dt>
      <dd>{{currentBoard.title}}</dd>
      <dt *ngIf="!statusHidden">Status</dt>
      <dd *ngIf="!statusHidden">
        <mat-form-field class="inprogress tiny-combobox pt-0" appearance="outline">
          <mat-select
            [disabled]="!hasPermissionForChangeStatus"
            (ngModelChange)="handleStatusChange($event)"
            [ngModel]="card.status"
            data-copilot="task-detail-select-status">
            <mat-option *ngFor="let status of statusList; let si=index" [value]="status.status" [attr.data-copilot]="'task-detail-option-status-' + si">
              {{status.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </dd>
      <dt *ngIf="hasPriorities && !priorityHidden">Priority</dt>
      <dd *ngIf="hasPriorities && !priorityHidden">
        <mat-form-field class="tiny-combobox pt-0 {{selectedPriority.priorityClass}}" appearance="outline">
          <mat-select
            (ngModelChange)="handlePriorityChange($event)"
            [ngModel]="selectedPriority.id"
            data-copilot="task-detail-select-priority">
            <mat-option *ngFor="let priority of priorities; let pi=index" [value]="priority.id" [attr.data-copilot]="'task-detail-option-priority-' + pi">
              <span [style]="'color:' + priority.colorCode">{{priority.title}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </dd>
      <!--      <dt>Labels</dt>
            <dd><a href="#" (click)="onAddLabels()">Add Label</a></dd>-->
      <dt>{{startDateHeader}}</dt>
      <dd class="start-date"><a (click)="onStartDateClicked(taskMenuItems['SubTask'])"
                                [ngClass]="{'disabled': !hasPermission}"
                                data-copilot="task-detail-btn-start-date">{{startDate ? (startDate | date: 'd MMMM y hh:mm a') : startDateLabel}}</a>
      </dd>
      <dt>{{dueDateHeader}}</dt>
      <dd class="due-date"><a (click)="onDueDateClicked(taskMenuItems['SubTask'])"
                              [ngClass]="{'disabled': !hasPermission}"
                              data-copilot="task-detail-btn-due-date">{{dueDate ? (dueDate | date: 'd MMMM y hh:mm a') : dueDateLabel}}</a>
      </dd>
      <dt *ngIf="taskMenuItems.hasOwnProperty('TaskAssignee')">People</dt>
      <dd *ngIf="taskMenuItems.hasOwnProperty('TaskAssignee')" class="people"><a
        (click)="onMenuChange(taskMenuItems['TaskAssignee'])"
        data-copilot="task-detail-btn-people">{{card.sharedPeopleDisplayText ? card.sharedPeopleDisplayText : 'Add'}}</a>
      </dd>
      <dt *ngIf="taskMenuItems.hasOwnProperty('TaskRole')">Roles</dt>
      <dd *ngIf="taskMenuItems.hasOwnProperty('TaskRole')" class="roles"><a
        (click)="onMenuChange(taskMenuItems['TaskRole'])"
        data-copilot="task-detail-btn-roles">{{card.taskRolesDisplayText ? card.taskRolesDisplayText : 'Add'}}</a>
      </dd>
      <dt *ngIf="taskMenuItems.hasOwnProperty('TaskAlert')">Notifications</dt>
      <dd *ngIf="taskMenuItems.hasOwnProperty('TaskAlert')"><a
        (click)="onMenuChange(taskMenuItems['TaskAlert'])"
        data-copilot="task-detail-btn-notifications">{{card.taskAlertCount}} Notifications</a></dd>
      <dt *ngIf="taskMenuItems.hasOwnProperty('TaskOccurrence') && (!card.parentTicket)">Occurrences</dt>
      <dd *ngIf="taskMenuItems.hasOwnProperty('TaskOccurrence') && (!card.parentTicket)"><a
        (click)="onMenuChange(taskMenuItems['TaskOccurrence'])"
        data-copilot="task-detail-btn-occurrences">{{card.occurrenceCount}} Occurrences</a></dd>
      <dt *ngIf="taskMenuItems.hasOwnProperty('SubTask') && (!card.parentTicket)">Subtasks</dt>
      <dd *ngIf="taskMenuItems.hasOwnProperty('SubTask') && (!card.parentTicket)"><a
        (click)="onMenuChange(taskMenuItems['SubTask'])"
        data-copilot="task-detail-btn-subtasks">{{card.subtaskCount}} Subtasks</a></dd>
      <dt *ngIf="supportClientAccessEnabled && isSupportUser">Access</dt>
      <dd class="magic-link" *ngIf="supportClientAccessEnabled && isSupportUser && crossCompanyAccessInfo">
        <a *ngIf="crossCompanyAccessInfo.showRequestAccess" (click)="onRequestAccess()">Request Access</a>
        <a *ngIf="crossCompanyAccessInfo.showPendingAccess"> Access Request Pending</a>
        <a *ngIf="crossCompanyAccessInfo.showOpenCompany" (click)="onOpenClientCompany()">Open Client Company</a>
      </dd>
    </dl>
    <div *ngIf="isSupportUser && currentBoardId == supportBoardId" class="m-t-20 rich-text-editor-contianer">
      <h2>Resolution</h2>
      <app-support-resolution [resolution]="card.resolution" [ticketId]="card.id"></app-support-resolution>
    </div>
  </div>
</div>



